export default "__VITE_ASSET__CpOuKqx4__"